/**
 * Show or hide the social icon list on click
 * @param {Event} event - The click event object
 */
export const toggleSocialIconList = (event) => {
    event.preventDefault()
    const btn = event.currentTarget
    let target = document.querySelector(btn.dataset.target)

    if (!target) {
        const parent = btn.closest('.social-share')
        target = parent.querySelector('.mec-event-sharing')
    }

    if (target) {
        target.classList.toggle('show')
        btn.setAttribute('aria-expanded', target.classList.contains('show'))
    }
}
